// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalAddStage_wrapper__Fv7Kj","head":"ModalAddStage_head__y6nHQ","content":"ModalAddStage_content__43u5w"};